import { render } from "./AdminOverview.vue?vue&type=template&id=2aa27558&scoped=true"
import script from "./AdminOverview.vue?vue&type=script&lang=js"
export * from "./AdminOverview.vue?vue&type=script&lang=js"

import "./AdminOverview.vue?vue&type=style&index=0&id=2aa27558&scoped=true&lang=css"

import exportComponent from "/home/kitrin/builds/isoevolve/20261004-205117/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2aa27558"]])

export default __exports__